import {Column, HeaderProps} from 'react-table'
import {INotification} from '../_model'
import {PropsWithChildren} from 'react'
import {CustomHeader} from '../../../utils/components/table-content/CustomHeader'
import SelectionHeader from '../../../utils/components/table-content/SelectionHeader'
import {ListViewContext} from '../../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../../utils/components/table-content/SelectionCell'
import {KTIcon} from '../../../../_metronic/helpers'
import NotificationActionCell from '../components/NotificationActionCell'

const notificaitonsListColumn = (
  handleShow: (id: number) => void
): ReadonlyArray<Column<INotification>> => [
  {
    Header: (props) => <SelectionHeader tableProps={props as any} context={ListViewContext} />,
    id: 'selection',
    Cell: ({...props}) => (
      <SelectionCell id={props.data[props.row.index].id} context={ListViewContext} />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<INotification>>) => (
      <CustomHeader tableProps={props} title='notification' className='min-w-100px' />
    ),
    id: 'notify_text',
    accessor: 'notify_text',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<INotification>>) => (
      <CustomHeader tableProps={props} title='send date' className='min-w-100px' />
    ),
    id: 'send_date',
    accessor: 'send_date',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<INotification>>) => (
      <CustomHeader tableProps={props} title='' className='min-w-100px' />
    ),
    id: 'action',
    Cell: ({...props}) => (
      <NotificationActionCell notification={props.data[props.row.index]} handleShow={handleShow} />
    ),
  },
]

export default notificaitonsListColumn
